import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import dialogPlugin, { dialog } from 'BASE/plugins/dialogPlugin';
import router from 'XH/router';
import store from 'XH/store/store';
import ajaxSetting from 'BASE/components/ajaxSetting.component';
import App from 'XH/views/App.vue';
import dialogComponent from 'XH/views/Dialog.vue';
import VueClipboard from 'vue-clipboard2';
import Loading from 'vue-loading-overlay';
import loginPlugin from 'BASE/plugins/loginPlugin';
import logoComponent from 'XH/views/Logo.vue';
import LoadingComponent from 'XH/views/Loading.vue';
import 'vue2-datepicker/locale/zh-cn';  //統一變更時間選擇器語系
import VueCircleSlider from 'vue-circle-slider'
import 'BASE/filters/numberFilter'; // 增加number的Filter
import numberPlugin from 'BASE/plugins/numberPlugin';
import vueIframe from 'BASE/plugins/vue-iframes';
import datadogRumPlugin from 'BASE/plugins/datadogRumPlugin';
import UrlManager from 'BASE/common/UrlManager';

Vue.use(UrlManager);
sync(store, router);
Vue.use(dialogPlugin, { dialogComponent });
Vue.use(loginPlugin, { router, dialog });
Vue.use(numberPlugin);
Vue.use(vueIframe);

VueClipboard.config.autoSetContainer = true; //讓vue-clipboard2將container 設置為當前元素，避免在Bootstrap 模式不工作
Vue.use(VueClipboard);

Vue.use(require('vue-moment'));

Vue.use(VueCircleSlider);

Vue.component('custom-loader', LoadingComponent);
Vue.use(Loading, {
    loader: 'spinner',
    width: 64,
    height: 64,
    zIndex: 9999,
    backgroundColor:'rgba(0,0,0,0.6)',
},{
    default: (new Vue()).$createElement('custom-loader'),           
});

Vue.use(datadogRumPlugin, { isMobile: false });

Vue.component('logo', logoComponent);

new Vue({
    router,
    store,
    render: h => h(App),
    mixins: [ajaxSetting]
}).$mount('#app');
